import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "seq-date-range" }
const _hoisted_2 = {
  class: "seq-date-range__preset",
  ref: "presetRef"
}
const _hoisted_3 = { class: "svg-icon svg-icon-5 ms-1" }
const _hoisted_4 = {
  key: 0,
  class: "seq-date-range__preset-menu"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "seq-date-range__divider" }, null, -1)
const _hoisted_6 = { class: "seq-date-range__display" }
const _hoisted_7 = { class: "seq-date-range__label" }
const _hoisted_8 = { class: "seq-date-range__calendar-wrap" }
const _hoisted_9 = {
  type: "button",
  class: "seq-date-range__calendar-btn",
  title: "Select custom date range"
}
const _hoisted_10 = { class: "svg-icon svg-icon-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_el_date_picker = _resolveComponent("el-date-picker")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        type: "button",
        class: "seq-date-range__preset-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePresetMenu && _ctx.togglePresetMenu(...args)))
      }, [
        _createVNode("span", null, _toDisplayString(_ctx.preset), 1),
        _createVNode("span", _hoisted_3, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Angle-down.svg" })
        ])
      ]),
      (_ctx.presetMenuOpen)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.presetOptions, (option) => {
              return (_openBlock(), _createBlock("button", {
                key: option,
                type: "button",
                class: ["seq-date-range__preset-option", { 'is-active': _ctx.preset === option }],
                onClick: ($event: any) => (_ctx.selectPreset(option))
              }, _toDisplayString(option), 11, ["onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      _createVNode("span", _hoisted_7, _toDisplayString(_ctx.dateRangeLabel), 1),
      _createVNode("div", _hoisted_8, [
        _createVNode("button", _hoisted_9, [
          _createVNode("span", _hoisted_10, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Interface/Calendar.svg" })
          ])
        ]),
        (_ctx.customRange)
          ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 0,
              modelValue: _ctx.customRange,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.customRange = $event)),
              type: "daterange",
              class: "seq-date-range__picker-overlay",
              "unlink-panels": "",
              format: "DD MMM YYYY",
              "value-format": "YYYY-MM-DD",
              "disabled-date": _ctx.disabledDate,
              onChange: _ctx.onCustomRangeChange
            }, null, 8, ["modelValue", "disabled-date", "onChange"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}